import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:offer.index" },
      { key: "[c].name", name: "global:offer.contact.contact" },
      { key: "title", name: "global:offer.title" },
      {
        key: "[cb].firstName+lastName",
        name: "global:offer.createdBy",
      },
      { key: "[s].name", name: "global:offer.status" },
    ],
    selectedSearchFields: [
      "index",
      "[c].name",
      "title",
      "[cb].firstName+lastName",
      "[s].name",
    ],
    dictionaryFields: ["offerType", "customerType"],
    url: "offer",
  },
};

const offerReducer = createSlice({
  name: "offerReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = offerReducer.actions;

export default offerReducer.reducer;
